import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { differenceInYears, differenceInMonths } from "date-fns";
import { roundNearest100 } from "../utils/helpers";
import Counter from "./Counter";
import { useScrollTop } from "../utils/useScrollTop";

const STATISTICS_BASE = {
	experience: {
		label: "years",
		initialData: new Date("2002-01-01"),
	},
	clients: {
		label: "clients",
		initialData: 60, //clients / month
	},
	orders: {
		label: "orders",
		initialData: 90, //orders / month
	},
};

const HomeStats = ({ counterCanStart }) => {
	useScrollTop();
	const { t } = useTranslation();
	const [statistics, setStatistics] = useState([]);

	useEffect(() => {
		let stats = [];
		//COMPUTE TOTAL YEARS
		let currYearsExp = differenceInYears(
			new Date(),
			STATISTICS_BASE.experience.initialData
		);
		//COMPUTE TOTAL MONTHS
		let currMonthsExp = differenceInMonths(
			new Date(),
			STATISTICS_BASE.experience.initialData
		);
		//COMPUTE TOTAL CLIENTS (clientsNo/month * totalMonths)
		let currClients = currMonthsExp * STATISTICS_BASE.clients.initialData;
		//COMPUTE TOTAL ORDERS (idem)
		let currOrders = currMonthsExp * STATISTICS_BASE.orders.initialData;
		currClients = roundNearest100(currClients);
		currOrders = roundNearest100(currOrders);

		stats = [currYearsExp, currClients, currOrders];

		let currStatistics = Object.entries(STATISTICS_BASE).map((item, index) => ({
			label: item[1].label,
			data: stats[index],
		}));

		setStatistics(currStatistics);
	}, []);

	return (
		<div className='statistics-container' id='home-stats'>
			{statistics.map((item, index) => (
				<div className='stats-item' key={index}>
					<p className='stats-label stats-prefix'>
						{t("homepage.counter.over")}
					</p>
					<Counter
						to={item.data}
						className={"counter"}
						canStart={counterCanStart}
					/>
					<p className='stats-label'>{t(`homepage.counter.${item.label}`)}</p>
				</div>
			))}
		</div>
	);
};

export default HomeStats;
